module.exports = __webpack_public_path__ + "img/4.cbf5e592.gif";